<template>
  <div class="hidden lg:flex flex-col h-full">
    <div class="flex-1" />
    <div class="flex items-start mt-8">
      <div class="flex items-center justify-start flex-wrap *:my-0.5 -my-0.5 *:mx-0.5 -mx-0.5">
        <vetster-category-badge
          :title="postType"
          is-large
        />
        <vetster-category-badge
          :title="post.species_type?.name"
          is-large
        />
      </div>
    </div>
    <vetster-publish-date
      :post="post"
      is-stacked
    />
  </div>
</template>

<script>
import VetsterCategoryBadge from '@/brand-components/Content/PetHealth/VetsterCategoryBadge';
import VetsterPublishDate from '@/brand-components/Content/VetsterPublishDate';

export default {
  name: 'VetsterEditorialTopRightContent',

  components: {
    VetsterCategoryBadge,
    VetsterPublishDate,
  },

  props: {
    post: {
      type: Object,
      required: true,
    },
    postType: {
      type: String,
      required: true,
    },
  },
};
</script>
